import React from 'react';
import PropTypes from 'prop-types';
import { partition } from 'lodash';
import { Modal } from 'react-bootstrap';
import snakecaseKeys from 'snakecase-keys';

import TaskForm from 'components/tasks/task_form';

export default class AddToCallListModal extends React.Component {
  static propTypes = {
    availableDatabases: PropTypes.array.isRequired,
    callList: PropTypes.shape({
      id: PropTypes.number.isRequired,
      marketingListingsAccess: PropTypes.bool,
      taskAssociationsEnabled: PropTypes.bool
    }),
    currentUser: PropTypes.shape({
      id: PropTypes.number.isRequired,
      marketingListingsAccess: PropTypes.bool
    }).isRequired,
    databaseMembers: PropTypes.array.isRequired,
    defaultAssociatedModels: PropTypes.array.isRequired,
    selectedContacts: PropTypes.arrayOf(PropTypes.shape({
      name: PropTypes.string,
      unloaded: PropTypes.bool
    })).isRequired,
    shown: PropTypes.bool.isRequired,
    onCancel: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired
  };

  render() {
    const { callList, shown, selectedContacts, onCancel } = this.props;
    return (
      <Modal backdrop="static" className="bulk-tasks-modal" show={shown} onHide={onCancel}>
        <Modal.Header closeButton>
          <Modal.Title name="modal-title">
            Add {selectedContacts.length} Contacts to {callList && callList.name}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {this.renderTaskForm()}
        </Modal.Body>
      </Modal>
    );
  }

  renderTaskForm() {
    const {
      availableDatabases,
      callList,
      currentUser,
      defaultAssociatedModels,
      selectedContacts,
      databaseMembers,
      shown,
      onCancel,
      onSubmit
    } = this.props;

    if (!shown) return null;

    const defaultAssignee = snakecaseKeys(databaseMembers.find(member => member.id === currentUser.id) || {});
    const [unloaded, loaded] = partition(selectedContacts, contact => contact.unloaded);

    let selected = loaded.map(contact => contact.name).join(', ');

    if (unloaded.length > 0) {
      selected += `, and ${unloaded.length} more`;
    }

    return (
      <TaskForm
        assigneeOptions={snakecaseKeys(databaseMembers)}
        availableDatabaseOptions={availableDatabases}
        callListMode="existing"
        defaultAssociatedModels={defaultAssociatedModels}
        defaultTaskAssignee={defaultAssignee}
        defaultTaskList={callList}
        hideByProjectSelect={!currentUser.marketingListingsAccess}
        hideContactSelect
        hideProjectSelect={!currentUser.marketingListingsAccess}
        providedTitle="Call with [{Contact}]"
        saveButtonLabel="Add to Call List"
        selectedContacts={selected}
        showAssociationToggle

        onCancel={onCancel}
        onSave={onSubmit}
      />
    );
  }
}
